import React, { Fragment } from "react"
import { renderRoutes, RouteConfig } from "react-router-config"

function App({ route }: RouteConfig) {
    return (
        <Fragment>
            {renderRoutes(route.routes)}
        </Fragment>
    )
}

export default App
